
let onUnauthorizedCallback: null | (() => void) = null;

export const setOnUnauthorized = (cb: () => void) => {
  onUnauthorizedCallback = cb;
};

export const triggerOnUnauthorized = () => {
  if (onUnauthorizedCallback) onUnauthorizedCallback();
};
